import App from "./draftCompanion/App";
import DynastyTradingPage from "./dynastyTrading/pages/DynastyTradingPage";
import LeagueOfLegendsPage from "./dynastyTrading/leagueOfLegends/LeagueOfLegendsPage";
import TierChartPage from "./tierChart/TierChartPage";
import VideoViewPage from "./videoView/VideoViewPage";
import { useEffect, useState } from "react";

const HOME_SCREEN_LAUNCH_PATH_KEY = "fantasy-board:preferred-launch-path";

function normalizePath(pathname: string) {
  if (!pathname) return "/";
  const trimmed = pathname.endsWith("/") && pathname !== "/" ? pathname.slice(0, -1) : pathname;
  return trimmed || "/";
}

function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;
  const mediaStandalone = typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches;
  const navigatorStandalone = "standalone" in window.navigator && Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
  return mediaStandalone || navigatorStandalone;
}

function isNativeCapacitorShell() {
  if (typeof window === "undefined") return false;
  const capacitor = (window as any).Capacitor;
  return Boolean(capacitor?.isNativePlatform?.()) || window.location.protocol === "capacitor:";
}

function StartupLoadingScreen() {
  return (
    <div
      aria-live="polite"
      aria-busy="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 18,
      }}
    >
      <img
        src="/fantasydownloadlogo.png"
        alt="Fantasy Download"
        style={{
          width: "min(220px, 58vw)",
          height: "auto",
          display: "block",
        }}
      />
      <div
        style={{
          fontSize: 16,
          lineHeight: 1,
          fontWeight: 800,
          letterSpacing: 0,
          color: "rgba(255,255,255,0.86)",
        }}
      >
        Loading...
      </div>
    </div>
  );
}

export default function Root() {
  const path = normalizePath(typeof window === "undefined" ? "/" : window.location.pathname);
  const [showStartupLoading, setShowStartupLoading] = useState(() => isNativeCapacitorShell());

  useEffect(() => {
    if (!isNativeCapacitorShell()) {
      setShowStartupLoading(false);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setShowStartupLoading(false), 900);
    return () => window.clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (path === "/draftcompanion" || path === "/dynastytrading" || path === "/videoview" || path === "/leagueoflegends" || path === "/tierchart") {
      window.localStorage.setItem(HOME_SCREEN_LAUNCH_PATH_KEY, path);
      return;
    }
    if (path !== "/") return;

    const preferredLaunchPath = window.localStorage.getItem(HOME_SCREEN_LAUNCH_PATH_KEY);
    if (isStandaloneDisplayMode() && preferredLaunchPath === "/dynastytrading") {
      window.location.replace("/dynastytrading");
      return;
    }

    window.location.replace("/draftcompanion");
  }, [path]);

  let page = null;
  if (path === "/draftcompanion") {
    page = <App />;
  } else if (path === "/dynastytrading") {
    page = <DynastyTradingPage />;
  } else if (path === "/videoview") {
    page = <VideoViewPage />;
  } else if (path === "/leagueoflegends") {
    page = <LeagueOfLegendsPage />;
  } else if (path === "/tierchart") {
    page = <TierChartPage />;
  }

  return (
    <>
      {page}
      {showStartupLoading ? <StartupLoadingScreen /> : null}
    </>
  );
}
